import { BAUEN_URLS } from '@f-fertighaus/../@ba/getUrl'
import { BUNGALOW_URLS } from '@f-fertighaus/../@bu/getUrl'
import { EINFAMILIENHAUS_URLS } from '@f-fertighaus/../@eh/getUrl'
import { FERTIGHAUS_URLS } from '@f-fertighaus/../@f/getUrl'
import { IMMONET_URLS } from '@f-fertighaus/../@in/getUrl'
import { IMMOWELT_URLS } from '@f-fertighaus/../@iw/getUrl'
import { MASSIVHAUS_URLS } from '@f-fertighaus/../@mh/getUrl'
import { Domain } from '@f-fertighaus/applications/Next/pages/house-detail-page/HDPContent'
import { $TSFixMe } from '@f-fertighaus/applications/Next/types/TSFixMe'

const URLDictionary = {
  fertighaus: FERTIGHAUS_URLS,
  massivhaus: MASSIVHAUS_URLS,
  einfamilienhaus: EINFAMILIENHAUS_URLS,
  bungalow: BUNGALOW_URLS,
  bauen: BAUEN_URLS,
  immowelt: IMMOWELT_URLS,
  immonet: IMMONET_URLS
}

export const getUrlByDomain = (
  domain: Domain
): ((key: keyof typeof FERTIGHAUS_URLS) => $TSFixMe) => {
  return (key: keyof typeof FERTIGHAUS_URLS) => {
    return URLDictionary[domain][key]
  }
}

export const getUrl =
  typeof window !== 'undefined' && getUrlByDomain(window.__DOMAIN__)
